import _ from "lodash";
import React, { memo, useCallback, useMemo } from "react";
import { Dropdown, IconButton } from "@toddle-edu/ds-web";
import { ConfigureColumnsOutlined } from "@toddle-edu/ds-icons";
import ConfigureColumnsOverlay from "UIComponents/ConfigureColumnsOverlay";

const TEST_ID_PREFIX = "unitPlan-standardSelections-configureColumnsWrapper";

const ConfigureColumnsWrapper = props => {
  const {
    columnIdsForConfigureModal,
    properties,
    currentColumns,
    updateColumns,
  } = props;

  const data = useMemo(() => {
    return _.map(columnIdsForConfigureModal, columnId => {
      const columnHeaderConfig = properties[columnId].headerConfig;
      const { title, titleForConfigureColumns } = columnHeaderConfig;

      return {
        id: columnId,
        value: titleForConfigureColumns || title,
      };
    });
  }, [columnIdsForConfigureModal, properties]);

  const onSelectColumn = useCallback(
    selectedCols =>
      updateColumns({
        columnOrder: data,
        selectedColumns: selectedCols,
      }),
    [data, updateColumns]
  );

  const onReorderColumns = useCallback(
    updatedColumns =>
      updateColumns({
        columnOrder: updatedColumns,
        selectedColumns: currentColumns,
      }),
    [currentColumns, updateColumns]
  );

  return (
    <Dropdown
      overlay={
        <ConfigureColumnsOverlay
          data={data}
          selectedColumns={currentColumns}
          onSelectColumn={onSelectColumn}
          onReorderColumns={onReorderColumns}
          testId={TEST_ID_PREFIX}
        />
      }
      placement="bottomRight"
    >
      <IconButton
        icon={<ConfigureColumnsOutlined />}
        type="outlined"
        variant="neutral"
        testId={TEST_ID_PREFIX}
      />
    </Dropdown>
  );
};

export default memo(ConfigureColumnsWrapper);
